/* eslint-disable consistent-return */

import { Form } from './styles';
import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FrameData } from '../../components/FrameData';
import { IReclamante } from '../../dtos/Reclamante';
import { loginReclamante } from '../../api/services/Reclamante';
import { prefix } from '../../router';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useToast } from 'components/Toast/ToastProvider';
import { AutoRow } from 'components/AutoRow';
import Input from 'components/AutoRow/components/Input';
import { Button } from 'components/AutoRow/components/Button';
import { Title } from 'components/AutoRow/components/Title';
import { Paragraph } from 'components/AutoRow/components/Paragraph';
import { HoverClick } from 'components/AutoRow/components/HoverClick';

const IframeLogin = ({ history }: RouteComponentProps) => {
  const [, setAccessToken] = useLocalStorage<string | undefined>('accessToken', '');
  const [, setRefreshToken] = useLocalStorage<string | undefined>('refreshToken', '');
  const [, setDadosReclamante] = useLocalStorage<IReclamante | string>('reclamante', '');
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [dadosLogin, setDadosLogin] = useState({
    email: '',
    password: '',
  });
  const toast = useToast();

  function handleSetState(event: React.ChangeEvent<HTMLInputElement>) {
    const { value, name } = event.target;
    setDadosLogin((oldValue) => ({ ...oldValue, [name]: value }));
  }

  async function handleLogin(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setLoadingSubmit(true);
    const res = await loginReclamante(dadosLogin);
    setLoadingSubmit(false);

    if (res.failed) {
      return toast.addToast({ type: 'error', description: res.message });
    }

    if (!res.data || !res.data.complainant) {
      return toast.addToast({ type: 'error', description: 'Usuário ou senha inválidos!' });
    }

    const { 'x-access-token': accessToken, 'x-refresh-token': refreshToken } = res.headers;

    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
    setDadosReclamante(res.data.complainant);

    toast.addToast({
      type: 'success',
      description: 'Usuário logado com sucesso!',
    });

    history.push(`${prefix}/home`);
  }

  function handleRedirectToCreateUser() {
    history.push(`${prefix}/new-account`);
  }

  function handleRedirectForgotPassword() {
    history.push(`${prefix}/forgot`);
  }

  function handleRedirectGenerateAnonimo() {
    history.push(`${prefix}/generate`);
  }

  return (
    <FrameData>
      <Form id="form-login" onSubmit={handleLogin}>
        <AutoRow>
          <Title line="34px" label="Bem-vindo(a) ao portal do usuário de Iluminação Pública" />

          <Paragraph
            label="Para solicitar manutenções nas lâmpadas de sua cidade, é necessário informar email e senha"
            marginBottom={16}
            marginTop={-4}
          />

          <Input
            handleFunction={handleSetState}
            value={dadosLogin.email}
            name="email"
            label="Email"
            type="email"
            required
          />

          <Input
            handleFunction={handleSetState}
            name="password"
            label="Senha"
            type="password"
            value={dadosLogin.password}
            required
          />

          <HoverClick label="Gerar uma ocorrência anônima" onClick={handleRedirectGenerateAnonimo} switchSides />
          <HoverClick label="Esqueceu a senha?" onClick={handleRedirectForgotPassword} />

          <Button onClick={handleRedirectToCreateUser}>Criar uma conta</Button>

          <Button loading={loadingSubmit} type="submit" form="form-login">
            Entrar
          </Button>
        </AutoRow>
      </Form>
    </FrameData>
  );
};

export default IframeLogin;
